<script setup lang="ts">
import { useFormValidation } from "../../../../../composables/useFormValidation";
import { required } from "../../../../../utils/validation";
import TextInput from "../../../../../components/ui/form/TextInput.vue";
import FileUpload from "../../../../../components/ui/form/FileUpload.vue";
import { api } from "../../../../../api/Api";
import Toast from "../../../../../services/Toast";
import { Permission } from "../../../../../types/auth";
import { ref, onMounted } from "vue";
import ModalFormTemplate from "../../../../../components/ui/Templates/ModalFormTemplate.vue";

const props = defineProps<{
  data?: any | null;
  mode: "create" | "edit" | "view" | "showQuickView" | "toggleStatus";
  title: string | null;
  endPoint: string;
  permissions?: Permission[];
  listCreateName?: string;
  item?: any | null;
}>();

const emit = defineEmits<{
  (e: "save", data: any): void;
  (e: "close"): void;
}>();

const {
  fields,
  formData,
  setFieldRules,
  validateForm,
  resetForm,
  setFormData,
} = useFormValidation({
  items_id: props.data?.items_id || props.item?.id || "",
  item: props.data?.item || props.item?.name || "",
  path: props.data?.path || "",
  caption: props.data?.caption || "",
  active: props.data?.active || true,
  uid: props.data?.uid || "",
});

setFieldRules("items_id", [required("Item is required")]);
setFieldRules("item", [required("Item is required")]);
setFieldRules("path", [required("Photo is required")]);

const handleSubmit = async (close: boolean, newRecord: boolean) => {
  if (validateForm()) {
    const action = formData.value.uid != "" ? "update" : "create";
    const response = await api.post(
      (props.endPoint.slice(-1) == "/" || props.endPoint.slice(-1) == "-"
        ? props.endPoint
        : props.endPoint + "/") + action,
      formData.value
    );
    if (response.success == true) {
      Toast.show("saved successfully");
      emit("save", response.data);
      if (close) {
        emit("close");
      } else if (newRecord) {
        resetForm();
      } else {
        setFormData(response.data);
      }
    }
  }
};

const isReadOnly = ref(true);
onMounted(() => {
  isReadOnly.value = props.mode == 'view'
  if (props.mode == 'create') {
      resetForm()
    } else if (props.data) {
      setFormData(props.data)
    }
})


</script>
<template>
  <ModalFormTemplate
    :data="data"
    :mode="mode"
    :title="title"
    :endPoint="endPoint"
    :perm="permissions"
    :listCreateName="listCreateName"
    :tabList="[]"
    :formData="formData"
    @save="handleSubmit"
    @close="$emit('close')"
  >
    <template #form>
      <div class="grid md:grid-cols-1 gap-6">
        <TextInput
          v-model="fields.item.value"
          label="Item"
          :readonly="true"
          :error="fields.item.touched ? fields.item.error : null"
          @blur="fields.item.touched = true"
        />
      </div>
      <div>
        <FileUpload
          label="Photo"
          accept=".pdf,.png,.jpg,.jpeg,.txt,.xls,.xlsx,.dox,.docx,.html,.xml"
          :max-size="5"
          :multiple="false"
          :readonly="isReadOnly"
          :image="true"
          path="items"
          v-model="fields.path.value"
        />
      </div>
      <div class="grid md:grid-cols-2 gap-6">
        <TextInput
          v-model="fields.caption.value"
          label="Caption"
          :readonly="isReadOnly"
          :error="fields.caption.touched ? fields.caption.error : null"
          @blur="fields.caption.touched = true"
        />
      </div>
    </template>
  </ModalFormTemplate>
</template>
